import { z } from 'zod';

export const MIMETypeSchema = z.object({
  idMIMEType: z.number().int(),
  MIMEType: z.string(),
  FileExtension: z.string(),
});

export type IMIMEType = z.infer<typeof MIMETypeSchema>;
